/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ArrowRight/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconArrowForward from 'DesignSystem/Svgs/TysiaIconArrowForward/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ArrowRight({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/ArrowRight",
  scrollContainerRef,
  isAtEnd
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let arrowsIsScrollableValueData = fromData.useDataValue({ viewPath,
context: 'arrows',
path: 'isScrollable',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  scrollContainerRef,
  isAtEnd
  
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<button
  data-testid="ArrowRight.Vertical"
  data-view-path={viewPath}
 scrollContainerRef={scrollContainerRef}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-iaeGf': dtColorsWhite,'--d-2-iaeGf': arrowsIsScrollableValueData ? "flex" : "none"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconArrowForward
  viewPath={`${viewPath}/TysiaIconArrowForward`}
 height={14}
 fill={isAtEnd ? dtColorsNeutral300 : dtColorsNeutral500}
 data="arrows.isAtEnd"
/>
</button>
{children}
</React.Fragment>)
}